// extracted by mini-css-extract-plugin
export default {"item":"AppointmentHistoryItem_item__mcJSA","date":"AppointmentHistoryItem_date__Z0cgS","content":"AppointmentHistoryItem_content__fvU8J"};